import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeItemListItem = style({
    ...csstips.flexRoot,
    paddingTop: 15,
    paddingBottom: 15,
    position: 'relative',
    textDecoration: 'none',
    paddingLeft: 15,
    paddingRight: 15,
    $nest: {
        '&:last-child': {
            $nest: {
                '&::after': {
                    content: `" "!important`,
                    background: 'rgba(0, 0, 0, 0)!important'
                }
            },
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8
        },
        '&:active': {
            backgroundColor: '#f8f8f8'
        },
        '&::after': {
            content: `" "`,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            height: 1,
            bottom: 0,
            background: '#E6E6E6',
            transform: 'scaleY(0.3)'
        }
    }
})

export const HomeItemLeftBgImage = style({
    width: '100%',
    height: 67,
    position: 'relative',
    overflow: 'hidden',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const StudyTotalNum = style({
    width: '100%',
    height: 22,
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    position: 'relative',
    background: '#F4F4F4',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '12px',
    $nest: {
        '& img': {
            width: 10,
            marginRight: 5
        }
    }
})

export const StudyTotalNumDiv = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    marginLeft: 1
})

export const HomeItemRight = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.vertical,
    marginLeft: 10,
    width: 'calc(100% - 120px)'
})

export const HomeItemRightTitle = style({
    fontSize: 16,
    fontWeight: 500,
    color: 'rgba(51,51,51,1)',
    lineHeight: '22px',
    marginTop: -3
})

export const HomeItemRightFreeLecture = style({
    fontWeight: 500
})

export const HomeItemRightBotton = style({
    ...csstips.flexRoot,
    ...csstips.end,
    lineHeight: '10px',
    overflow: 'visible',
    fontSize: 12,
    $nest: {
        '& span': {
            fontSize: 12,
            color: '#FF3F3C'
        },
        '& p': {
            fontSize: 14,
            color: '#FF3F3C',
            fontWeight: 500
        },
        '& del': {
            fontWeight: 400,
            fontSize: 10,
            color: '#999999'
        }
    }
})

export const HomeItemRightBottonRight = style({
    ...csstips.flexRoot
})

export const HomeItemRightBottonRightLimit = style({
    fontSize: 16
})

export const HomeItemLeftBottom = style({
    ...csstips.flexRoot,
    ...csstips.end,
    ...csstips.betweenJustified,
    marginBottom: 5
})

export const couponTagSm = style({
    padding: '4px 4px',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
    backgroundColor: '#FF3F3C',
    fontSize: 10,
    right: 0,
    bottom: 15,
    borderRadius: 3
})

export const couponTagSmText = style({
    fontSize: 12,
    transform: 'scale(1)',
    fontWeight: 600
})

export const youXuanType = style({
    top: 2,
    position: 'relative',
    marginRight: 4,
    height: 16,
    width: 35,
    display: 'inline-block'
})

export const couponTagBig = style({
    background: '#ff3f3c',
    opacity: 0.9,
    position: 'absolute',
    width: 70,
    height: 70,
    transform: 'rotate(45deg)',
    top: -35,
    left: -35
})

export const couponTagBigText = style({
    position: 'absolute',
    color: '#fff',
    fontSize: 12,
    top: 5,
    left: 5,
    transform: 'scale(1)',
    fontWeight: 600
})

export const HomeItemLeft = style({
    width: 120,
    position: 'relative',
    overflow: 'hidden',
    background: '#f4f4f4',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4
})

export const LiveStatusImg = style({
    width: 19,
    height: 12,
    marginRight: 5
})

export const isLivingText = style({
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    textAlign: 'justify',
    lineHeight: '12px'
})

export const threeActivity = style({
    display: 'inline-block',
    fontSize: 10,
    color: '#FFFFFF',
    letterSpacing: 0,
    lineHeight: '14px',
    padding: '1px 3px 1px 3px',
    background: '#F44336',
    borderRadius: 2,
    position: 'relative',
    top: -2,
    marginRight: 5
})



// WEBPACK FOOTER //
// ./src/views/Home/components/TriennialsSpecial/HomeItemListItem/HomeItemListItem.style.ts